'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.masonFetchStylesheetsSuccess = exports.masonFetchStylesheetsRequest = exports.MASON_FETCH_STYLESHEETS_SUCCESS = exports.MASON_FETCH_STYLESHEETS_REQUEST = exports.MASON_FETCH_COMPONENTS_FAILURE = exports.MASON_FETCH_COMPONENTS_SUCCESS = exports.MASON_FETCH_COMPONENTS_REQUEST = exports.addCallback = exports.MASON_ADD_CALLBACK = exports.setOptions = exports.MASON_SET_OPTIONS = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.fetchComponents = fetchComponents;
exports.fetchProjects = fetchProjects;
exports.fetchStylesheets = fetchStylesheets;

var _reduxActions = require('redux-actions');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _api = require('../middleware/api');

var _http = require('../utils/http');

var _http2 = _interopRequireDefault(_http);

var _css = require('../utils/css');

var _mason = require('../utils/mason');

var _mason2 = _interopRequireDefault(_mason);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var MASON_SET_OPTIONS = exports.MASON_SET_OPTIONS = 'MASON_SET_OPTIONS';
var setOptions = exports.setOptions = (0, _reduxActions.createAction)(MASON_SET_OPTIONS);
var MASON_ADD_CALLBACK = exports.MASON_ADD_CALLBACK = 'MASON_ADD_CALLBACK';
var addCallback = exports.addCallback = (0, _reduxActions.createAction)(MASON_ADD_CALLBACK);
var MASON_FETCH_COMPONENTS_REQUEST = exports.MASON_FETCH_COMPONENTS_REQUEST = 'MASON_FETCH_COMPONENTS_REQUEST';
var MASON_FETCH_COMPONENTS_SUCCESS = exports.MASON_FETCH_COMPONENTS_SUCCESS = 'MASON_FETCH_COMPONENTS_SUCCESS';
var MASON_FETCH_COMPONENTS_FAILURE = exports.MASON_FETCH_COMPONENTS_FAILURE = 'MASON_FETCH_COMPONENTS_FAILURE';
var MASON_FETCH_STYLESHEETS_REQUEST = exports.MASON_FETCH_STYLESHEETS_REQUEST = 'MASON_FETCH_STYLESHEETS_REQUEST';
var MASON_FETCH_STYLESHEETS_SUCCESS = exports.MASON_FETCH_STYLESHEETS_SUCCESS = 'MASON_FETCH_STYLESHEETS_SUCCESS';
var masonFetchComponentsRequest = (0, _reduxActions.createAction)(MASON_FETCH_COMPONENTS_REQUEST);
var masonFetchComponentsSuccess = (0, _reduxActions.createAction)(MASON_FETCH_COMPONENTS_SUCCESS);
var masonFetchComponentsFailure = (0, _reduxActions.createAction)(MASON_FETCH_COMPONENTS_FAILURE);
var masonFetchStylesheetsRequest = exports.masonFetchStylesheetsRequest = (0, _reduxActions.createAction)(MASON_FETCH_STYLESHEETS_REQUEST);
var masonFetchStylesheetsSuccess = exports.masonFetchStylesheetsSuccess = (0, _reduxActions.createAction)(MASON_FETCH_STYLESHEETS_SUCCESS);

function fetchComponents(cIds, onSuccess) {
  return _defineProperty({}, _api.CALL_API, function (getState) {
    return {
      endpoint: (0, _mason2.default)(getState().mason).urls.components({
        cIds: cIds
      }),
      verb: _http2.default.GET,
      lifecycleActions: [masonFetchComponentsRequest, function (response) {
        if (_lodash2.default.isFunction(onSuccess)) {
          return masonFetchComponentsSuccess(_extends({}, response, {
            components: onSuccess(response.components)
          }));
        }

        return masonFetchComponentsSuccess(response);
      }, masonFetchComponentsFailure]
    };
  });
}

function fetchProjects(pIds, onSuccess) {
  return _defineProperty({}, _api.CALL_API, function (getState) {
    return {
      endpoint: (0, _mason2.default)(getState().mason).urls.components({
        pIds: pIds
      }),
      verb: _http2.default.GET,
      lifecycleActions: [masonFetchComponentsRequest, function (response) {
        if (_lodash2.default.isFunction(onSuccess)) {
          return masonFetchComponentsSuccess(_extends({}, response, {
            components: onSuccess(response.components, response.projects)
          }));
        }

        return masonFetchComponentsSuccess(response);
      }, masonFetchComponentsFailure]
    };
  });
}

function fetchStylesheets(pIds, components, projects, getStylesheetUrl, onSuccess, draft) {
  return function (dispatch) {
    dispatch(masonFetchStylesheetsRequest());
    return (0, _css.validateProjectStylesheet)(projects, getStylesheetUrl, draft).then(function (results) {
      return dispatch(masonFetchStylesheetsSuccess(results));
    }).then(onSuccess);
  };
}